var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0708 44.0256C50.2909 42.7994 41.9542 46.6041 41.4533 52.5311C40.9524 58.4525 48.4785 64.2533 58.2621 65.4814C68.0458 66.7076 76.3806 62.901 76.8833 56.974C77.3823 51.0545 69.8582 45.2537 60.0708 44.0256Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6552 91.3838C18.0039 97.1476 1.85547 85.7314 1.85547 85.7314",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9583 87.4186C40.5206 94.8815 50.5361 108.596 64.6681 110.321C84.2428 112.701 96.8759 94.6033 96.8759 94.6033C99.8792 93.4012 105.149 91.8077 107.47 90.8022C119.489 85.608 122.724 83.8272 124.195 77.4123C126.282 68.3132 123.283 49.8162 119.068 41.8339C114.397 32.9722 104.122 23.9102 83.7289 21.0274C83.1873 19.0555 81.1114 17.4008 78.442 17.0613C75.5128 16.6921 72.9046 18.0259 72.1478 20.1239C71.1034 20.0998 70.0422 20.085 68.9552 20.0887C38.5097 20.2316 30.1934 39.6171 30.1934 39.6171L28.2048 59.4496L27.4164 66.3005L2 86.0365C2 86.0365 14.8353 81.7216 25.9583 87.4186Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.b88e6d96810127a1c63625acc2f95322.svg";
export { ForwardRef as ReactComponent };